import React, { Component } from 'react';
import { Redirect, Link } from 'react-router-dom';
import '../Alumnos/AlumnoForm.css';
import '../Alumnos/MDAlumnos.css';
import * as constantClass from '../fileWithConstants';
import { isSubmitInProgress } from '../../services/formSubmitGuard';
import { LookupAlumnos } from '../Alumnos/LookupAlumnos';
import { LookupCarreras } from '../Carreras/LookupCarreras';

function BackIcon() {
  return (
    <svg className="md-page__icon md-page__icon--sm" viewBox="0 0 24 24" aria-hidden="true">
      <path d="M19 12H5M12 19l-7-7 7-7" />
    </svg>
  );
}

export class AddAlumnoCarrera extends Component {
  static displayName = AddAlumnoCarrera.name;

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      errorMessage: '',
      redirect: false,
      anioInicio: new Date().getFullYear().toString(),
      tagData: [],
      alumno: { alumnoDni: '', alumnoCodigo: 0, alumnoNombre: '' },
      showLookupStudent: false,
      showLookupCarreras: false,
    };
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    constantClass.canAccess('WWAlumnosxCarrera');
  }

  clearFeedback() {
    if (this.state.errorMessage) {
      this.setState({ errorMessage: '' });
    }
  }

  handleSelectStudentItem = (e) => {
    const studentProperties = e.split('%');
    this.clearFeedback();
    this.setState({
      alumno: {
        alumnoDni: studentProperties[0],
        alumnoNombre: studentProperties[1],
        alumnoCodigo: parseInt(studentProperties[2], 10),
      },
      showLookupStudent: false,
    });
  };

  handleSelectCarreraItem = (e) => {
    const carreraProperties = e.split('%');
    const tag = { id: carreraProperties[0], text: carreraProperties[1] };
    this.clearFeedback();
    this.setState((prev) => ({
      showLookupCarreras: false,
      tagData: prev.tagData.some((t) => t.id === tag.id) ? prev.tagData : [...prev.tagData, tag],
    }));
  };

  handleShowStudentLookup = () => {
    if (!this.state.loading) {
      this.setState({ showLookupStudent: true });
    }
  };

  handleShowCarreraLookup = () => {
    if (!this.state.loading) {
      this.setState({ showLookupCarreras: true });
    }
  };

  handleHideStudentLookup = () => {
    this.setState({ showLookupStudent: false });
  };

  handleHideCarreraLookup = () => {
    this.setState({ showLookupCarreras: false });
  };

  handleDeleteTag = (id) => {
    this.clearFeedback();
    this.setState((prev) => ({ tagData: prev.tagData.filter((tag) => tag.id !== id) }));
  };

  isFormValid() {
    return (
      Number(this.state.alumno.alumnoCodigo) > 0
      && this.state.tagData.length > 0
      && this.isAnioInicioValid()
    );
  }

  isAnioInicioValid() {
    const year = parseInt(this.state.anioInicio, 10);
    return Number.isInteger(year) && year >= 1900 && year <= 2100;
  }

  handleAnioInicioChange = (e) => {
    this.clearFeedback();
    this.setState({ anioInicio: e.target.value });
  };

  handleSubmit(e) {
    e.preventDefault();
    if (isSubmitInProgress(this.state.loading)) return;
    if (!this.isFormValid()) {
      if (!this.isAnioInicioValid()) {
        this.setState({ errorMessage: 'Ingrese un año de inicio válido (1900–2100).' });
        return;
      }
      this.setState({ errorMessage: 'Debe seleccionar un alumno y al menos una carrera.' });
      return;
    }
    this.saveRecord();
  }

  async saveRecord() {
    if (isSubmitInProgress(this.state.loading)) return;

    const anioInicio = parseInt(this.state.anioInicio, 10);
    const object = this.state.tagData.map((tag) => ({
      AlumnoCodigo: parseInt(this.state.alumno.alumnoCodigo, 10),
      CarreraCod: parseInt(tag.id, 10),
      AlumnoxCarreraAnioInicio: anioInicio,
    }));

    this.setState({ loading: true, errorMessage: '' });

    const { data } = await constantClass.apiFetch('api/axc', {
      method: 'POST',
      body: JSON.stringify(object),
    });

    if (data === 'Timeout') {
      constantClass.RedirectToLogin();
      return;
    }

    if (constantClass.isApiError(data) || data.returnModel === false) {
      this.setState({
        loading: false,
        errorMessage: constantClass.getApiErrorMessage(
          data,
          'No se pudo guardar el alumno por carrera. Verifique los datos e intente nuevamente.'
        ),
      });
      return;
    }

    this.setState({ loading: false, redirect: true });
  }

  renderCareerTags() {
    const { tagData, loading } = this.state;
    if (tagData.length === 0) {
      return <p className="md-form-page__empty-hint">Ninguna carrera seleccionada</p>;
    }
    return (
      <ul className="md-form-page__tags">
        {tagData.map((tag) => (
          <li key={tag.id} className="md-form-page__tag">
            <span>{tag.text}</span>
            <button
              type="button"
              className="md-form-page__tag-remove"
              onClick={() => this.handleDeleteTag(tag.id)}
              disabled={loading}
              aria-label={'Quitar ' + tag.text}
            >
              ×
            </button>
          </li>
        ))}
      </ul>
    );
  }

  render() {
    if (this.state.redirect) {
      return <Redirect to="/md-axc" />;
    }

    const { loading, errorMessage, alumno, anioInicio, showLookupStudent, showLookupCarreras } = this.state;
    const isBusy = loading;

    return (
      <div className="md-page md-form-page">
        <Link className="md-form-page__back" to="/md-axc">
          <BackIcon />
          Volver al listado
        </Link>

        <h1 className="md-form-page__title">Inscribir alumno</h1>
        <p className="md-form-page__subtitle">
          Seleccione un alumno existente, una o más carreras y el año de inicio en la carrera.
        </p>

        <div className="md-form-page__card">
          <form className="md-form-page__form" onSubmit={this.handleSubmit} noValidate>
            <div className="md-form-page__feedback" aria-live="polite" role="status">
              {errorMessage ? <span className="md-form-page__error">{errorMessage}</span> : null}
              {loading ? (
                <span className="md-form-page__loading">Guardando, espere un momento...</span>
              ) : null}
            </div>

            <div className="md-form-page__field">
              <span className="md-form-page__label">Alumno</span>
              <button
                type="button"
                className="md-form-page__pick-btn"
                onClick={this.handleShowStudentLookup}
                disabled={isBusy}
              >
                Seleccione el Alumno
              </button>
              {showLookupStudent ? (
                <LookupAlumnos
                  selectStudent={this.handleSelectStudentItem}
                  hideLookup={this.handleHideStudentLookup}
                />
              ) : null}
              <input
                className="md-form-page__input"
                type="text"
                value={alumno.alumnoDni}
                placeholder="DNI del alumno"
                readOnly
                disabled
                aria-label="DNI del alumno"
              />
              <input
                className="md-form-page__input"
                type="text"
                value={alumno.alumnoNombre}
                placeholder="Nombre del alumno"
                readOnly
                disabled
                aria-label="Nombre del alumno"
              />
            </div>

            <div className="md-form-page__field">
              <span className="md-form-page__label">Carreras</span>
              <button
                type="button"
                className="md-form-page__pick-btn"
                onClick={this.handleShowCarreraLookup}
                disabled={isBusy}
              >
                Seleccione la Carrera
              </button>
              {showLookupCarreras ? (
                <LookupCarreras
                  selectItem={this.handleSelectCarreraItem}
                  hideLookup={this.handleHideCarreraLookup}
                />
              ) : null}
              {this.renderCareerTags()}
            </div>

            <div className="md-form-page__field">
              <label className="md-form-page__label" htmlFor="axc-anio-inicio">
                Año de inicio en la carrera
              </label>
              <input
                id="axc-anio-inicio"
                className="md-form-page__input"
                type="text"
                name="anioInicio"
                inputMode="numeric"
                autoComplete="off"
                placeholder="Ej. 2024"
                value={anioInicio}
                onChange={this.handleAnioInicioChange}
                disabled={isBusy}
                required
              />
            </div>

            <div className="md-form-page__actions">
              <button type="submit" className="md-form-page__btn md-form-page__btn--primary" disabled={isBusy}>
                Confirmar
              </button>
            </div>
          </form>
        </div>
      </div>
    );
  }
}
